import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import "swiper/css";
import { Avatar } from "@mui/material";
import { StarIcon } from "@heroicons/react/solid";
import testimonialCards from "../data/testimonialCards";

const ReviewCard = () => {
  return (
    <>
      <Swiper
        slidesPerView={3}
        spaceBetween={80}
        speed={15000}
        autoplay={{
          delay: 1500,
          // waitForTransition: true,
          reverseDirection: false,
          // disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          //   renderBullet: true,
          //   dynamicBullets: true,
        }}
        breakpoints={{
          280: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },

          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
        }}
        modules={[Pagination, Autoplay]}
        className="mySwiper"
        // data-swiper-autoplay="2000"
      >
        {testimonialCards.map((item, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="max-w-[400px] hover:shadow-[0_8px_45px_-30px_rgba(0,0,0,0.3)] my-10 shadow-[0_4px_15px_-30_rgba(0,0,0,0.3)]  mx-auto text-center  py-12 md:px-6 px-4  bg-[#508dffde] rounded-xl">
                <div className="flex justify-center mx-auto text-center">
                  <Avatar src={item.img} sx={{ width: 54, height: 54 }} />
                </div>
                <div className="flex justify-center my-2 mt-3">
                  <StarIcon className="w-6 h-6 mx-[2px] text-orange-300" />
                  <StarIcon className="w-6 h-6 mx-[2px] text-orange-300" />
                  <StarIcon className="w-6 h-6 mx-[2px] text-orange-300" />
                  <StarIcon className="w-6 h-6 mx-[2px] text-orange-300" />
                  <StarIcon className="w-6 h-6 mx-[2px] text-orange-300" />
                </div>
                <h1 className="text-[20px] line-clamp-1 font-semibold">
                  {item.name}
                </h1>
                <p className="text-white text-[17px] leading-[30px] line-clamp-5 font-semibold mt-2">
                  It’s a real relief for me, because I don’t have a marketing
                  division. So I’m more than willing to work with Video Husky
                  who: 1. Can save me a lot of money, and 2. Can turn my vision
                  on paper into something extremely nice.
                </p>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default ReviewCard;
